export default "__VITE_ASSET__DpMs50CU__"